import React from "react";
import Image from "next/image";

interface Slide {
	src: string;
	alt: string;
}

interface ProductSlideshowSectionProps {
	slides?: Slide[];
}

const DEFAULT_SLIDES: Slide[] = [
	{ src: "/slide-show/usafbappmockup.png", alt: "USA FB App" },
	// { src: "/slide-show/Desktop-dashboard 1.png", alt: "Dashboard" },
	{ src: "/slide-show/yojomockup.png", alt: "Yojo App" },
	// Repeats for seamless loop
	{ src: "/slide-show/usafbappmockup.png", alt: "USA FB App" },
	// { src: "/slide-show/Desktop-dashboard 1.png", alt: "Dashboard" },
	{ src: "/slide-show/yojomockup.png", alt: "Yojo App" },
];

const ProductSlideshowSection = ({ slides = DEFAULT_SLIDES }: ProductSlideshowSectionProps) => {
	return (
		<div className="bg-white overflow-hidden px-2 xl:px-0">
			<div className="relative w-full overflow-hidden">
				<div className="flex animate-scroll w-max hover:[animation-play-state:paused] items-center">
					{/* Tripling for smooth scrolling */}
					{[...slides, ...slides, ...slides].map((slide, index) => (
						/* eslint-disable-next-line @next/next/no-img-element */
						<img
							key={index}
							src={slide.src}
							alt={slide.alt}
							className="h-[400px] md:h-[600px] w-auto max-w-none object-contain"
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default ProductSlideshowSection;
